import React, { useState, useEffect } from 'react';
import { Modal, Popconfirm, Tooltip } from 'antd';
import useWindowSize from 'src/utils/hooks//useWindowSize';
import { useDispatch, useSelector } from 'react-redux';
import chapterActions from 'src/redux/actions/chapterActions';
import chapterSelectors from 'src/redux/selectors/chapterSelectors';
import qs from 'qs';
import { InfoCircleTwoTone, InfoCircleOutlined, EditTwoTone, DeleteTwoTone } from '@ant-design/icons';
import comicActions from 'src/redux/actions/comicActions';
import ModalAddChapter from './ModalAddChapter';
import Loading from 'src/components/Loading';
import moment from 'moment';

const ModalChapters = ({ visible, onCancel, comic }) => {
  const dispatch = useDispatch();
  const { windowHeight } = useWindowSize();
  const loading = useSelector(chapterSelectors.loading);
  const chapters = useSelector(chapterSelectors.chapters);
  const [modalAddChapterVisible, setModalAddChapterVisible] = useState(false);
  const [editingChapter, setEditingChapter] = useState(null);

  const openModalAddChapter = () => setModalAddChapterVisible(true);
  const closeModalAddChapter = () => setModalAddChapterVisible(false);

  const fetchComics = () => {
    dispatch(comicActions.fetchComics());
  };

  const fetchChapters = () => {
    dispatch(chapterActions.fetchChapters({ comicId: comic.id }));
  };

  const previewChapter = (chapter) => {
    const encodedParams = qs.stringify({ comicName: comic.name, comicId: comic.id, chapterName: chapter.name, chapterId: chapter.id });
    window.open('/preview?' + encodedParams, '_blank');
  };

  const deleteChapter = (chapterId) => {
    dispatch(chapterActions.deleteChapter({ comicId: comic.id, chapterId }, () => {
      fetchChapters();
      fetchComics();
    }));
  };

  useEffect(() => {
    (comic && visible) && fetchChapters();
  }, [comic, visible]);

  return (
    <Modal
      title="Chapters"
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      centered
      bodyStyle={{ maxHeight: windowHeight - 200, overflowY: 'auto', paddingTop: 0, paddingBottom: 0 }}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
      destroyOnClose
    >
      <Loading loading={loading} />
      {Object.values(chapters).map((chapter, index) =>
        <ItemChapter
          key={chapter.id}
          chapter={chapter}
          isLastItem={index === Object.values(chapters).length - 1}
          previewChapter={previewChapter}
          deleteChapter={deleteChapter}
          setEditingChapter={(chapter) => {
            setEditingChapter(chapter);
            openModalAddChapter();
          }}
        />
      )}
      <ModalAddChapter
        visible={modalAddChapterVisible}
        onCancel={closeModalAddChapter}
        comic={comic}
        editingChapter={editingChapter}
      />
    </Modal>
  )
}

const ItemChapter = ({ chapter, isLastItem, previewChapter, deleteChapter, setEditingChapter }) => {

  return (
    <div style={{
      ...styles.chapterContainer,
      borderBottom: isLastItem ? 'none' : '1px solid #f2f2f2'
    }}>
      <a style={styles.chapterName} onClick={() => previewChapter(chapter)}>{chapter.name}</a>
      <Tooltip title={
        <div>
          <div style={styles.chapterInfo}>Created at: {moment(chapter.createdAt).format('MM/DD/YYYY hh:mm:ss')}</div>
          <div style={styles.chapterInfo}>Created by: {chapter.createdBy}</div>
          {chapter.updatedAt &&
            <>
              <div style={styles.chapterInfo}>Updated at: {moment(chapter.updatedAt).format('MM/DD/YYYY hh:mm:ss')}</div>
              <div style={styles.chapterInfo}>Updated by: {chapter.updatedBy}</div>
            </>
          }
        </div>
      }>
        <InfoCircleOutlined style={{ fontSize: 18, color: 'gray', cursor: 'pointer', marginLeft: 10 }} />
      </Tooltip>
      <EditTwoTone twoToneColor='gold' style={{ fontSize: 18, cursor: 'pointer', marginLeft: 10 }} onClick={() => setEditingChapter(chapter)} />
      <Popconfirm
        title="Are you sure to delete this chapter?"
        onConfirm={() => deleteChapter(chapter.id)}
        okText="Yes"
        cancelText="No"
      >
        <DeleteTwoTone twoToneColor='red' style={{ fontSize: 18, cursor: 'pointer', marginLeft: 10 }} />
      </Popconfirm>
    </div>
  );
};

const styles = {
  chapterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 5,
    paddingBottom: 5
  },
  chapterName: {
    flex: 1
  },
  chapterInfo: {
    color: '#b2b2b2'
  }
};

export default ModalChapters;